// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
    position: relative;
    background-color: rgb(85, 85, 85);
    padding: 1.5rem 0;    
}

.hero-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background-color: var(--home-primary-color);
    background-size: cover;
    background-position: center;
    background-blend-mode: overlay;
}

.hero-content {
    position: relative;
    z-index: 10;
    width: 100%;    
    margin: 0 auto;
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
    gap: 2rem;
}

.hero-logo {
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-background {
    background-color: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.7);
    padding: 1rem;
    border-radius: 50%;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
}

.logo-background:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.logo-image {
    height: 85px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

@media (min-width: 768px) {
    .hero-content {
        padding: 0 1.5rem;
    }
}

.hero-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
}

.hero-title {
    font-size: 1rem;
    font-weight: bold;
    letter-spacing: -0.05em;
    color: white;
    margin: 0;
    line-height: 1.4;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.hero-description {
    max-width: 700px;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
    line-height: 1.6;
}

.hero-actions {
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-button-home {
    display: inline-block;
    padding: 0.5rem 1.25rem;
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
}

.login-button-home:hover {
    background-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
    .hero-actions {
        top: 1rem;
        left: 1rem;
    }

    .login-button-home {
        padding: 0.4rem 1rem;
        font-size: 0.75rem;
    }
}

@media (min-width: 1024px) {
    .login-button-home {
        padding: 0.6rem 1.5rem;
        font-size: 1rem;
    }
}

@media (min-width: 640px) {
    .hero-title {
        font-size: 1.875rem;
    }
}

@media (min-width: 768px) {
    .hero-title {
        font-size: 2.25rem;
    }

    .hero-description {
        font-size: 1rem;
    }
}

@media (max-width: 767px) {
    .hero-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 1rem;
        gap: 1rem;
    }

    .hero-actions {
        position: static;
        order: 2;
        margin: 0.75rem 0;
        transform: none;
        left: auto;
    }

    .hero-text {
        order: 1;
        margin-top: 0;
    }

    .hero-title {
        order: 1;
        font-size: 1.3rem;
    }

    .hero-description {
        order: 3;
        font-size: 0.8rem;
        margin-top: 0.75rem;
    }

    .login-button-home {
        padding: 0.5rem 1.25rem;
        font-size: 0.8rem;
    }

    .logo-background {
        padding: 0.8rem;
    }

    .logo-image {
        height: 70px;        
    }
}

@media (max-width: 480px) {
    .hero-section {
        padding: 0;
    }

    .hero-title {
        font-size: 1.2rem;
    }

    .hero-description {
        font-size: 0.75rem;
    }

    .login-button-home {
        padding: 0.4rem 1rem;
    }

    .logo-background {
        padding: 0.5rem;        
    }

    .logo-image {
        height: 60px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,2CAA2C;IAC3C,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,QAAQ;QACR,iBAAiB;QACjB,eAAe;QACf,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,QAAQ;QACR,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".hero-section {\n    position: relative;\n    background-color: rgb(85, 85, 85);\n    padding: 1.5rem 0;    \n}\n\n.hero-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0;\n    background-color: var(--home-primary-color);\n    background-size: cover;\n    background-position: center;\n    background-blend-mode: overlay;\n}\n\n.hero-content {\n    position: relative;\n    z-index: 10;\n    width: 100%;    \n    margin: 0 auto;\n    padding: 0 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row-reverse;\n    gap: 2rem;\n}\n\n.hero-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.logo-background {\n    background-color: rgba(255, 255, 255, 0.5);\n    border: 1px solid rgba(255, 255, 255, 0.7);\n    padding: 1rem;\n    border-radius: 50%;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.3s ease;\n}\n\n.logo-background:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.logo-image {\n    height: 85px;\n    width: auto;\n    max-width: 100%;\n    object-fit: contain;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n@media (min-width: 768px) {\n    .hero-content {\n        padding: 0 1.5rem;\n    }\n}\n\n.hero-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.5rem;\n}\n\n.hero-title {\n    font-size: 1rem;\n    font-weight: bold;\n    letter-spacing: -0.05em;\n    color: white;\n    margin: 0;\n    line-height: 1.4;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.hero-description {\n    max-width: 700px;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.9);\n    margin: 0;\n    line-height: 1.6;\n}\n\n.hero-actions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.login-button-home {\n    display: inline-block;\n    padding: 0.5rem 1.25rem;\n    background-color: rgba(255, 255, 255, 0.2);\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    border-radius: 6px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    text-decoration: none;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(4px);\n}\n\n.login-button-home:hover {\n    background-color: rgba(255, 255, 255, 0.3);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 768px) {\n    .hero-actions {\n        top: 1rem;\n        left: 1rem;\n    }\n\n    .login-button-home {\n        padding: 0.4rem 1rem;\n        font-size: 0.75rem;\n    }\n}\n\n@media (min-width: 1024px) {\n    .login-button-home {\n        padding: 0.6rem 1.5rem;\n        font-size: 1rem;\n    }\n}\n\n@media (min-width: 640px) {\n    .hero-title {\n        font-size: 1.875rem;\n    }\n}\n\n@media (min-width: 768px) {\n    .hero-title {\n        font-size: 2.25rem;\n    }\n\n    .hero-description {\n        font-size: 1rem;\n    }\n}\n\n@media (max-width: 767px) {\n    .hero-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 1rem;\n        gap: 1rem;\n    }\n\n    .hero-actions {\n        position: static;\n        order: 2;\n        margin: 0.75rem 0;\n        transform: none;\n        left: auto;\n    }\n\n    .hero-text {\n        order: 1;\n        margin-top: 0;\n    }\n\n    .hero-title {\n        order: 1;\n        font-size: 1.3rem;\n    }\n\n    .hero-description {\n        order: 3;\n        font-size: 0.8rem;\n        margin-top: 0.75rem;\n    }\n\n    .login-button-home {\n        padding: 0.5rem 1.25rem;\n        font-size: 0.8rem;\n    }\n\n    .logo-background {\n        padding: 0.8rem;\n    }\n\n    .logo-image {\n        height: 70px;        \n    }\n}\n\n@media (max-width: 480px) {\n    .hero-section {\n        padding: 0;\n    }\n\n    .hero-title {\n        font-size: 1.2rem;\n    }\n\n    .hero-description {\n        font-size: 0.75rem;\n    }\n\n    .login-button-home {\n        padding: 0.4rem 1rem;\n    }\n\n    .logo-background {\n        padding: 0.5rem;        \n    }\n\n    .logo-image {\n        height: 60px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
